import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69fa3f86")

_pushScopeId("data-v-69fa3f86")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = { class: "image is-5by3" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { class: "media" }
const _hoisted_6 = { class: "media-content has-text-centered" }
const _hoisted_7 = { class: "title is-4 has-text-centered" }
const _hoisted_8 = { class: "content has-text-centered" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createBlock(_component_RouterLink, { to: _ctx.routePath }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("figure", _hoisted_3, [
            _createVNode("img", {
              src: _ctx.imageSrc,
              alt: "Placeholder image"
            }, null, 8, ["src"])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.name), 1)
            ])
          ]),
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.description), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
})